export default "__VITE_ASSET__305d92b6__"